import { TScreenType } from '../../utils/detectScreenType';

export const get = (data: any, path: any[]) => {
  const result = path.reduce<any>((acc, step) => {
    if (typeof acc === 'undefined') {
      return acc;
    }

    if (typeof step === 'string') {
      acc = acc[step];
    } else if (
      Array.isArray(acc) &&
      typeof step === 'object' &&
      step !== null
    ) {
      acc = acc.find(item => {
        return Object.entries(step).every(
          ([name, value]) => item[name] === value
        );
      });
    }

    return acc;
  }, data);

  return result;
};
